var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),(_vm.viewCompletaProfilo)?_c('CompletaProfilo',{on:{"confirm":_vm.confirm}}):_vm._e(),_c('screen',{staticClass:"modal-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }